export enum POST_HOG_EVENTS {
  START_SESSION_RECORDING = "START_SESSION_RECORDING",
}
